import rpc from '@square/dashboard-utilities/clients/rpc';
import { PublicPayrollService } from '@square/dashboard-protos/models/squareup/payroll/service';
export default PublicPayrollService.create(rpc());